import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookiesPolicy = () => {
  const whatsappNumber = '34667459830';
  const whatsappMessage = encodeURIComponent('Hola, me gustaría obtener más información sobre sus armarios a medida.');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className="bg-black/95 backdrop-blur-md border-b border-amber-500/20">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-16 w-auto" />
          </Link>
          <Link to="/" className="px-6 py-2.5 text-base font-semibold transition-all duration-300 text-white hover:text-amber-400 whitespace-nowrap cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>Volver al inicio
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Política de Cookies</h1>
          <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 mb-12"></div>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-400">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. ¿Qué son las cookies?</h2>
              <p>
                Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (ordenador, tablet o móvil) cuando visitas nuestra página web. Estas cookies nos permiten reconocer tu navegador y recordar cierta información sobre tu visita, mejorando así tu experiencia de navegación en <strong className="text-amber-500">Armarios Benno</strong>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. ¿Qué tipos de cookies utilizamos?</h2>
              
              <h3 className="text-xl font-semibold text-white mt-6 mb-3">Cookies técnicas o necesarias</h3>
              <p>
                Son esenciales para el funcionamiento de nuestra web. Permiten navegar por el sitio y utilizar sus funciones básicas. Sin estas cookies, algunos servicios no estarían disponibles.
              </p>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">Cookies de análisis</h3>
              <p>
                Nos ayudan a entender cómo los visitantes interactúan con nuestra web, recopilando información de forma anónima. Esto nos permite mejorar continuamente nuestro sitio y ofrecer una mejor experiencia al usuario interesado en armarios a medida.
              </p>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">Cookies de preferencias</h3>
              <p>
                Permiten que la web recuerde tus preferencias (como el idioma o la región) para ofrecerte una experiencia más personalizada.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Cookies de terceros</h2>
              <p>En nuestra web pueden utilizarse cookies de terceros para los siguientes fines:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-white">Google Analytics:</strong> Para analizar el tráfico web y el comportamiento de los usuarios</li>
                <li><strong className="text-white">Redes sociales:</strong> Para permitir compartir contenido en plataformas como Facebook, Instagram o Twitter</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Duración de las cookies</h2>
              <p>Según su duración, las cookies pueden ser:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-white">Cookies de sesión:</strong> Se eliminan automáticamente al cerrar el navegador</li>
                <li><strong className="text-white">Cookies persistentes:</strong> Permanecen en tu dispositivo durante un período determinado o hasta que las elimines manualmente</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. ¿Cómo gestionar las cookies?</h2>
              <p>
                Puedes configurar tu navegador para aceptar o rechazar todas las cookies, o para que te avise cuando se envíe una cookie. Ten en cuenta que si desactivas las cookies, algunas funcionalidades de nuestra web podrían no estar disponibles.
              </p>
              <p className="mt-4">Instrucciones para gestionar cookies en los principales navegadores:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer nofollow" className="text-amber-500 hover:underline">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer nofollow" className="text-amber-500 hover:underline">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer nofollow" className="text-amber-500 hover:underline">Safari</a></li>
                <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer nofollow" className="text-amber-500 hover:underline">Microsoft Edge</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Actualización de la política</h2>
              <p>
                Armarios Benno se reserva el derecho de modificar esta Política de Cookies en cualquier momento. Te recomendamos revisar esta página periódicamente para estar informado de cualquier cambio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Contacto</h2>
              <p>
                Si tienes alguna pregunta sobre nuestra Política de Cookies, puedes contactarnos en:
              </p>
              <p className="mt-2">
                <strong className="text-amber-500">Email:</strong> info@armariosbenno.com<br />
                <strong className="text-amber-500">Teléfono:</strong> 91 791 933<br />
                <strong className="text-amber-500">Dirección:</strong> Calle Escayolistas 13, 28891 Velilla de San Antonio, Madrid
              </p>
            </section>

            <p className="text-sm text-gray-600 mt-12">Última actualización: Enero 2025</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-amber-500/20 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-xs text-gray-600">© 2025 Armarios Benno. Todos los derechos reservados.</p>
          <a className="text-xs text-gray-600 hover:text-amber-500 transition-colors cursor-pointer mt-2 inline-block" href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer">
            Realizado por grupo Globaltis
          </a>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/34667459830?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
        <span className="absolute right-full mr-3 px-3 py-2 bg-white text-gray-800 text-sm font-medium rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          ¿Te ayudamos?
        </span>
      </a>
    </div>
  );
};

export default CookiesPolicy;
